import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "350",
  height: "150"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "bxhnqbgpea",
        x1: "-47.934%",
        x2: "98.157%",
        y1: "64.945%",
        y2: "38.301%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#D8E5C4"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#D8E5C4",
          "stop-opacity": ".25"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#bxhnqbgpea)",
      "fill-rule": "evenodd",
      d: "M130.503 151C82.2 151 37.307 136.395 0 111.36V46.922C33.394 80.332 79.535 101 130.503 101c71.444 0 133.402-40.607 164.056-100h54.759c-33.912 87.756-119.094 150-218.815 150",
      transform: "translate(0 -1)"
    }, null, -1)
  ])))
}
export default { render: render }